import React, { Component } from "react";
import { Tabs, Button } from "antd";
import { connect } from "react-redux";
import { interfaceActions } from "../../../../common/redux/actions";
import { Link } from "react-router-dom";

import { getAllVehicles } from "../../redux/actions/vehiclesActions";
import {
  updateFilterFieldsVehicles,
  searchVehicles,
  resetFiltersVehicles
} from "../../redux/actions/filters";
import { getModelsByBrandsKeys } from "../../redux/actions/getFieldsActions";

import * as URLs from "../../../../common/constants/systemUrls";
// компоненты контейнера
// import TopPanel from '../../components/vehicles/TopPanel/TopPanel';
import Filters from "../../components/vehicles/Filters/Filters";
import VehiclesTable from "../../components/vehicles/VehiclesTable/VehiclesTable";
// выдвигалка из настройки столбцов
import ColConfigDrawer from "../../components/vehicles/configTableColumns/ConfigTableColumns";

// стили
import "./vehicles.css";

const { TabPane } = Tabs;

const { setCaption } = interfaceActions;

class Vehicles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Каталог ТС",
      pagination: {
        pages: 5
      },
      filteredVehicles: [],
      activeTab: "1",
      isDrawerVisible: false,
      drawerCols: {
        productionYear: true,
        registerSignAndRegion: true,
        passengerCapacity: true,
        priceUsedVehicle: true,
        archiveData: true,
        carrier: false,
        colorName: false,
        diagnosticCard: false,
        osgoppValidUntil: false,
        kaskoValidUntil: false,
        executors: false
      }
    };

    this.props.setCaption({
      enabled: true,
      mainCaption: this.state.title,
      breadCrumbs: [
        // Путь для хлебных крошек
        { path: "/" + URLs.CONTROL_PANEL, breadcrumbName: "Панель управления" },
        { path: "/" + URLs.VEHICLES, breadcrumbName: this.state.title }
      ]
    });
  }

  MARKS = {
    actual: {
      includeStatusKey: "status_key[]=actual",
      forApplyFilters: "actualVehicles"
    },
    archive: {
      includeStatusKey: "status_key[]=archive",
      forApplyFilters: "archiveVehicles"
    }
  };

  componentDidMount() {
    this.props.getAllVehicles();
    // this.props.getArchiveVehicles();
  }

  static getDerivedStateFromProps(nextProps, state) {
    try {
      const { actualVehicles, archiveVehicles, filteredVehicles } = nextProps;
      return (state = {
        ...state,
        actualVehicles,
        archiveVehicles,
        filteredVehicles
      });
    } catch (error) {
      alert(error);
      return state;
    }
  }

  showDrawer = () => {
    this.setState({
      isDrawerVisible: true
    });
  };

  closeDrawer = () => {
    this.setState({
      isDrawerVisible: false
    });
  };

  onColsChange = e => {
    let { drawerCols } = this.state;
    this.setState({
      drawerCols: {
        ...drawerCols,
        [e.target.name]: e.target.checked
      }
    });
  };

  applyFilters = currentArr => {
    const { filteredVehicles } = this.state;
    this.setState(() => ({
      [currentArr]: filteredVehicles
    }));
  };

  changePaginationSize = e => {
    this.setState(() => ({
      pagination: {
        pages: Number(e)
      }
    }));
  };

  onTabsChange = activeTab => {
    this.setState(() => ({ activeTab }));
  };

  resetFilters = () => {
    this.props.resetFiltersVehicles();
    this.props.getAllVehicles();
  };

  onChangeSearch = e => {
    const { value } = e.target;
    this.props.searchVehicles(value);
  };

  handleFiltersChange = values => {
    const val = Object.keys(values).reduce((acc, key) => {
      if (values[key]) {
        if (Array.isArray(values[key]) && values[key].length === 0) {
          return acc;
        }
        acc[key] = values[key];
      }
      return acc;
    }, {});
    this.props.updateFilterFieldsVehicles(val);
  };

  render() {
    const {
      activeTab,
      drawerCols,
      isDrawerVisible,
      filteredVehicles,
      pagination
    } = this.state;
    const {
      actualVehicles,
      archiveVehicles,
      filtersStatus,
      isLoading,
      activeProfile
    } = this.props;
    return (
      <div id="vehicles" className="basicForm">
        {activeProfile.roleKey === "administrator" ||
        activeProfile.roleKey === "financier" ||
        activeProfile.roleKey === "manager" ||
        activeProfile.roleKey === "dispatcher" ? (
          <Link to="/vehicle_card/add">
            <Button type="link" id="add_vehicle">
              Добавить ТС
            </Button>
          </Link>
        ) : null}
        <Tabs
          type="card"
          activeKey={activeTab}
          onTabClick={this.onTabsChange}
          disabled={actualVehicles.length === 0}
        >
          <TabPane tab={`Активные: ${actualVehicles.length}`} key="1">
            <div id="activeVehiclesWrapper">
              <Filters
                {...this.props}
                showDrawer={this.showDrawer}
                marks={this.MARKS.actual}
                onChangeSearch={this.onChangeSearch}
                handleFiltersChange={this.handleFiltersChange}
                resetFilters={this.resetFilters}
              />
              <VehiclesTable
                filtersStatus={filtersStatus}
                pages={pagination.pages}
                columns={drawerCols}
                vehicles={filtersStatus ? filteredVehicles : actualVehicles}
                changePaginationSize={this.changePaginationSize}
                marks={this.MARKS.actual}
                isLoading={isLoading}
              />
            </div>
          </TabPane>
          <TabPane
            tab={`Архив: ${archiveVehicles.length}`}
            disabled={archiveVehicles.length === 0}
            key="2"
          >
            <div id="arhiveVehiclesWrapper">
              <Filters
                {...this.props}
                showDrawer={this.showDrawer}
                marks={this.MARKS.archive}
                onChangeSearch={this.onChangeSearch}
                handleFiltersChange={this.handleFiltersChange}
                resetFilters={this.resetFilters}
              />
              <VehiclesTable
                filtersStatus={filtersStatus}
                pages={pagination.pages}
                columns={drawerCols}
                vehicles={filtersStatus ? filteredVehicles : archiveVehicles}
                changePaginationSize={this.changePaginationSize}
                marks={this.MARKS.archive}
                isLoading={isLoading}
              />
            </div>
          </TabPane>
        </Tabs>
        <ColConfigDrawer
          columns={drawerCols}
          visible={isDrawerVisible}
          close={this.closeDrawer}
          changed={this.onColsChange}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    // CRUD data
    actualVehicles:
      state.Transport.Vehicles.filters.count > 0
        ? state.Transport.Vehicles.vehicles.actualFilterVehicles
        : state.Transport.Vehicles.vehicles.actualVehicles,
    archiveVehicles:
      state.Transport.Vehicles.filters.count > 0
        ? state.Transport.Vehicles.vehicles.archiveFilterVehicles
        : state.Transport.Vehicles.vehicles.archiveVehicles,
    filteredVehicles: state.Transport.Vehicles.filters.filteredVehicles,
    successMessage: state.Transport.Vehicles.vehicles.successMessage,
    errorMessage: state.Transport.Vehicles.vehicles.errorMessage,
    // filters
    filtersCount: state.Transport.Vehicles.filters.filtersCount,
    filtersData: state.Transport.Vehicles.filters.filtersData,
    filteredCount: state.Transport.Vehicles.filters.filteredCount,
    filtersStatus: state.Transport.Vehicles.filters.filtersStatus,
    isLoading: state.Transport.Vehicles.vehicles.isLoading,
    activeProfile: state.Authorization.activeProfile
  }),
  {
    setCaption,
    // CRUD METHODS
    getAllVehicles,
    // filters
    getModelsByBrandsKeys,
    updateFilterFieldsVehicles,
    searchVehicles,
    resetFiltersVehicles
  }
)(Vehicles);
